import { render, staticRenderFns } from "./StepTabOptions.vue?vue&type=template&id=0d4767a5&scoped=true"
import script from "./StepTabOptions.vue?vue&type=script&lang=js"
export * from "./StepTabOptions.vue?vue&type=script&lang=js"
import style0 from "./StepTabOptions.vue?vue&type=style&index=0&id=0d4767a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4767a5",
  null
  
)

export default component.exports